import { useBroadcastStorage } from './useBroadcastStorage';
import { EntityTypeEnum } from '../../gql/typings';
import { SearchTabsId } from './entity';

const generateLastUsedSearchKey = (entityType: EntityTypeEnum) => `${entityType}-last-used-search`;

export const useLastUsedSearch = (
  entityType: EntityTypeEnum
) => useBroadcastStorage<number>(generateLastUsedSearchKey(entityType), +SearchTabsId.Simple);
